import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { ENUM_INVOICE_TYPE } from "../creditdebitnote/enum"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem } from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, funValidateNoInput, getModMandatory, getModValue, getModVisiblity, linksUrl } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faFilter, faMicroscope, faPlus, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DataGrid } from "@mui/x-data-grid"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { Box, Drawer } from "@mui/material"
import debounce from 'lodash.debounce';
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/masterItemEntrySlice"

const RowsField = {
    id: "id",
    detailId: "detailId",
    fedNo: "fedNo",
    itemName: "itemName",
    itemCode: "itemCode",
    denier: "denier",
    ends: "ends",
    wastagePer: "wastagePer",
    wastageWeight: "wastageWeight",
    totalWeight: "totalWeight",
    shade: "shade",
    colorId: "colorId",
    perMtrWeight: "perMtrWeight",
    yarnItem: "yarnItem",
    yarnItemCode: "yarnItemCode",
    fedType: "fedType",
    totalPick: "totalPick",
    size: "size",
    entryOf: "entryOf"
}
export const InputCell = ({
    row,
    input_id,
    input_type,
    is_readonly,
    holder_text,
    is_required,
    variant,
    color,
    handleInputChange,
    handleKeyDown,
    hanldeBlur,
    gridType
}) => {
    const [localValue, setLocalValue] = useState(row[input_id] ?? "");

    useEffect(() => {

        setLocalValue(row[input_id] ?? "");
    }, [row[input_id]]);

    const onBlur = (e) => {
        if (localValue !== row[input_id]) {
            handleInputChange(row.id, { target: { value: localValue, id: RowsField[input_id] } });
        }

        hanldeBlur(row.id, e);



    };
    const handleChange = (e) => {
        const { id, value } = e.target
        let isValid = true
        if ([RowsField.denier, RowsField.fedNo, RowsField.perMtrWeight, RowsField.wastagePer, RowsField.wastageWeight, RowsField.totalWeight, RowsField.totalPick, RowsField.ends].includes(id))
            isValid = funValidateNoInput(value)
        if (isValid)
            setLocalValue(value)

    }
    return (
        <Input
            isRequired={is_required}
            id={RowsField[input_id]}
            type={input_type}
            size="sm"
            labelPlacement="outside"
            readOnly={is_readonly}
            placeholder={holder_text}
            onKeyDown={(e) => handleKeyDown(row.id, e)}
            value={localValue}
            //onChange={(e) => setLocalValue(e.target.value)}
            onChange={handleChange}
            onBlur={onBlur}
            className="max-w-xs mt-1"
            variant={variant || "bordered"}
            color={color || ""}
        />
    );
};
const CreateMasterItem = () => {
    const { compCode, appType } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.masterItemEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const gridContainerRef = useRef();
    const gridContainerWeftRef = useRef();
    const [modeSettingParams, setModSettingParams] = useState()
    const [selRowIndex, setSelRowIndex] = useState(0)
    const [costSetting, setCostSetting] = useState(0)
    const [rowsWeft, setRowsWeft] = useState([])
    const [weavRatePerPick, setWeavRatePerPick] = useState("")
    const [basePick, setBasePick] = useState("")
    const [itemSettings, setItemSettings] = useState()
    const gridWeft = "weft"
    const [openDrawer, setOpenDrawer] = useState(false);
    const [showYarnCost, setShowYarnCost] = useState(false);
    const [yarnCostData, setYarnCostData] = useState([]);


    const { isError: isErrorModSet, isPending: isPendingMod, data: modSetting = [], mutate: funModSetting } = usePost({
        url: apiRoute.modeSetting.getModSetting,
        queryKey: "fetchModSetting",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                
                const costval = getModValue(ENUM_MOD_PARAMETER.masterItem.CostMeter, data)
                setItemSettings({
                    defWidth: getModValue(ENUM_MOD_PARAMETER.masterItem.DefWidth, data) || 47,// 
                    defWarpWastage: getModValue(ENUM_MOD_PARAMETER.masterItem.DefWarpWastage, data) || 5,
                    defWeftWastage: getModValue(ENUM_MOD_PARAMETER.masterItem.DefWeftWastage, data) || 5,
                    defPickConst: getModValue(ENUM_MOD_PARAMETER.masterItem.DefPickConstant, data) || 256
                })
                setCostSetting(costval)
            }
            else {
                
                setItemSettings({ defWidth: 47, defWarpWastage: 5, defWeftWastage: 5, defPickConst: 256 })
                setCostSetting(100)
            }
        }
    })

    useEffect(() => {
        funModSetting({
            data: {
                mod_name: ENUM_MOD_NAME.MasterItem
            }
        })

    }, [])


    const { isLoading, data: masterData = [] } = useFetchWithBody({
        url: apiRoute.masterItemEntry.entryMasterData,
        queryKey: "getMasterData",
        inputData: {
            compcode: compCode.join(",")
        }
    })


    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.masterItemEntry.add_update,
        queryKey: "funAddUpdateMasterItem",
        onSuccessTasks: (data) => {
            setShowYarnCost(true)
            toast.success(`Items ${isNewEntry ? " Added" : " Updated"}`, {
                position: "top-center"
            })
            //navigate(linksUrl.masterItemEntry.masterItemEntryMaster);
        }
    })
    const { data = [], isPending: isPendingYarn, mutate: funGetYarnCost } = usePost({
        url: apiRoute.masterItemEntry.getYarnCost,
        queryKey: "fungetyarnCost",
        onSuccessTasks: (data) => {
            setYarnCostData(data)
        }
    })

    const { isPending: isPendingItmUp, mutate: funUpdateItemRate } = usePost({
        url: apiRoute.masterItemEntry.updateItemRate,
        queryKey: "funUpdateOItemrate",
        onSuccessTasks: (data) => {
            funFilterYarnCost()
            toast.success("Rate Updated", {
                "position": 'top-center'
            })
        }
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePostMutateWithSuccess({
        url: apiRoute.masterItemEntry.fetchEntryDetail,
        queryKey: "fetchMasterItemDetail",
    });



    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            const { MItem_Code } = detailParams
            funGetDetail({
                data: {
                    mitem_code: MItem_Code
                },

            })
        }
    }, [])


    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [deletedWeftItemRows, setDeletedWeftItemRows] = useState([])

    const formField = {
        grayItemCode: "grayItemCode",
    }
    const [rows, setRows] = useState([])

    const initialRow = {
        [RowsField.detailId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.denier]: "",
        [RowsField.ends]: "",
        [RowsField.shade]: "",
        [RowsField.colorId]: "",
        [RowsField.perMtrWeight]: "",
        [RowsField.wastagePer]: "",
        [RowsField.wastageWeight]: "",
        [RowsField.totalWeight]: "",
        [RowsField.entryOf]: "C"
    }
    const initialRowWeft = {
        [RowsField.detailId]: 0,
        [RowsField.fedNo]: "",
        [RowsField.fedType]: "",
        [RowsField.totalPick]: "",
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.denier]: "",
        [RowsField.size]: "",
        [RowsField.shade]: "",
        [RowsField.colorId]: "",
        [RowsField.perMtrWeight]: "",
        [RowsField.wastagePer]: "",
        [RowsField.wastageWeight]: "",
        [RowsField.totalWeight]: "",
    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        acc[key] = ""
        return acc
    }, {})

    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const inputBoxes = {
        Row1: [
            {
                id: formField.grayItemCode,
                name: formField.grayItemCode,
                placeholder: "Gray Item",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.grayMaster ? masterData?.grayMaster : [],
                itemkey: "Item_Code",
                itemvalue: "Item_Desc",
                isrequired: true,
            }],



    }
    function roundAwayFromZero(value, decimals = 0) {
        const factor = Math.pow(10, decimals);
        if (value >= 0) {
            return Math.round(value * factor + Number.EPSILON) / factor;
        } else {
            return -Math.round(-value * factor + Number.EPSILON) / factor;
        }
    }

    function calcWeftWeight(width, pick, denier) {
        // costMeterValue is equivalent to mTpSetting.Cost_Meter.Value

        let dblWeight_Per_Mtr;

        if (Number(costSetting) === 100) {
            dblWeight_Per_Mtr = roundAwayFromZero(
                (Number(width) * pick * denier * 102) / (9000 * 1000),
                3
            );
        } else {
            dblWeight_Per_Mtr = roundAwayFromZero(
                (Number(width) * pick * denier * Number(costSetting)) / (9000 * 1000),
                3
            );
        }

        dblWeight_Per_Mtr = roundAwayFromZero(dblWeight_Per_Mtr, 3);

        return dblWeight_Per_Mtr;
    }

    const calculateWeight = (row) => {

        const weight = parseFloat(row[RowsField.perMtrWeight] || 0);
        const wastagePer = parseFloat(row[RowsField.wastagePer] || 0);

        const wastageWt = (weight * wastagePer) / 100;
        const totalWeight = weight + wastageWt;

        return {
            wastageWt: parseFloat(wastageWt.toFixed(3)),
            totalWeight: parseFloat(totalWeight.toFixed(3)),
        };
    };

    const calculateWarpWeight = (denier, ends) => {
        return ((denier * ends * costSetting) / (9000 * 1000));
    };

    const debouncedUpdaterRef = useRef(null);
    const weftDebounceRef = useRef(null);

    const handleWeftInputChange = useCallback((rowId, e) => {
        const { value, id } = e.target;

        weftDebounceRef.current = debounce((rowId, id, value) => {
            setRowsWeft((prevData) => {
                const index = prevData.findIndex((row) => row.id === rowId);
                if (index === -1) return prevData;

                const updatedRow = {
                    ...prevData[index],
                    [id]: value

                };

                if (id === RowsField.denier || id === RowsField.totalPick || id === RowsField.wastagePer) {

                    const denier = parseFloat(updatedRow[RowsField.denier] || 0);
                    const pick = parseFloat(updatedRow[RowsField.totalPick] || 0) / parseFloat(itemSettings.defPickConst || 0);

                    //console.log(itemSetting.defPickConst,totalpick,denier)

                    const perMtrWt = calcWeftWeight(itemSettings.defWidth, pick, denier);
                    updatedRow[RowsField.perMtrWeight] = parseFloat(perMtrWt.toFixed(3));

                    const calc = calculateWeight(updatedRow);
                    updatedRow[RowsField.wastageWeight] = calc.wastageWt;
                    updatedRow[RowsField.totalWeight] = calc.totalWeight;
                }

                const newData = [...prevData];
                newData[index] = updatedRow;
                return newData;
            });
        }, 50);


        weftDebounceRef.current(rowId, id, value);
    }, [itemSettings]);


    const handleInputChange = useCallback((rowId, e) => {
        const { value, id } = e.target;
        if (!debouncedUpdaterRef.current) {

            debouncedUpdaterRef.current = debounce((rowId, id, value) => {
                setRows((prevData) => {
                    const index = prevData.findIndex((row) => row.id === rowId);
                    if (index === -1) return prevData;

                    const updatedRow = {
                        ...prevData[index],
                        [id]: value,
                    };

                    // // 🔥 Auto calculate


                    if (id === RowsField.denier || id === RowsField.ends || id === RowsField.wastagePer) {
                        const denier = parseFloat(updatedRow[RowsField.denier] || 0);
                        const ends = parseFloat(updatedRow[RowsField.ends] || 0);

                        const perMtrWt = calculateWarpWeight(denier, ends);
                        updatedRow[RowsField.perMtrWeight] = parseFloat(perMtrWt.toFixed(3));

                        const calc = calculateWeight(updatedRow);
                        updatedRow[RowsField.wastageWeight] = calc.wastageWt;
                        updatedRow[RowsField.totalWeight] = calc.totalWeight;
                    }

                    const newData = [...prevData];
                    newData[index] = updatedRow;
                    return newData;
                });
            }, 50);

            // debouncedUpdaterRef.current = debounce((rowId, id, value) => {
            //     setRows((prevData) => {
            //         const index = prevData.findIndex((row) => row.id === rowId);
            //         if (index === -1) return prevData;
            //         const newData = [...prevData];
            //         newData[index] = { ...newData[index], [id]: value };
            //         return newData;
            //     });
            // }, 50); // 300ms delay

        }

        debouncedUpdaterRef.current(rowId, id, value);

    }, [costSetting]);

    const funGridSetting = (value, id, index, gridType) => {
        let rowId = RowsField.totalWeight
        if (id == rowId) {
            let lastRow = rows.length
            if (gridType == gridWeft)
                lastRow = rowsWeft.length

            if (index == lastRow) {
                funGenGridRows(1, gridType);
            }
        }
    }

    const handleKeyDown = (index, event) => {
        setSelRowIndex(index)
        if (event.key === 'Tab') {
            const { value, id } = event.target
            funGridSetting(value, id, index, "wrap")


        }
        else {
            if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                return; // Do nothinghanldeBlur
            } else {
                event.stopPropagation(); // Prevent other keys from propagating
            }
        }
    };

    const handleWeftKeyDown = (index, event) => {
        setSelRowIndex(index)
        if (event.key === 'Tab') {

            const { value, id } = event.target
            funGridSetting(value, id, index, gridWeft)


        }
        else {
            if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                return; // Do nothinghanldeBlur
            } else {
                event.stopPropagation(); // Prevent other keys from propagating
            }
        }
    };

    const hanldeBlur = (rowid, e) => {
        const { value, id, name } = e.target


        if (isMobile) {
            setSelRowIndex(rowid)
            funGridSetting(value, id, rowid, "")
        }
    }

    const hanldWefteBlur = (rowid, e) => {
        const { value, id, name } = e.target


        if (isMobile) {
            setSelRowIndex(rowid)
            funGridSetting(value, id, rowid, gridWeft)
        }
    }


    const itemGridHeadClass = "bill-grid-simple"

    const columns = [
        {
            field: RowsField.id,
            headerName: "No.",
            width: 30,
            headerAlign: "center",
            align: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <div className="flex gap-2 font-semibold">
                    {row.id}
                    <strong>

                        <FontAwesomeIcon
                            color="red"
                            className="cursor-pointer text-md"
                            onClick={() => handleDeleteRow(row.id, "")}
                            icon={faSquareXmark}

                        ></FontAwesomeIcon>
                    </strong>
                </div>
            ),
        },

        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            width: 100,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.itemCode}
                    input_type="text"
                    is_readonly={true}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"

                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            //renderInputCell(row, RowsField.itemCode, "text", true, "", false, "", ""),

        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            width: 200,
            //isVisible:true,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <Autocomplete
                    isRequired
                    size="sm"
                    id={RowsField.itemName}
                    eventResizeFeature={true}
                    selectionMode="single"
                    showScrollIndicators={true}
                    placeholder="--Select--"
                    className="max-w-23"
                    isLoading={isLoading}
                    isClearable={false}
                    readOnly={false}
                    isVirtualized
                    value={row.itemName}
                    menuTrigger={"input"}
                    defaultItems={
                        masterData && masterData.yarnMaster ? masterData?.yarnMaster : []
                    }
                    onSelectionChange={(e) =>
                        handleAutoCompleteChange(e, row.id, "", "")
                    }
                    selectedKey={row.itemCode}
                    color={"success"}
                    variant="flat"
                >
                    {(item) => (
                        <AutocompleteItem
                            key={item.Item_Code}
                        >
                            {item.Item_Code + "(" + item.Item_Desc + ")"}
                        </AutocompleteItem>
                    )}
                </Autocomplete>


            ),
        },
        {
            field: RowsField.denier,
            headerName: "Denier",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.denier}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={true}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            //renderInputCell(row, RowsField.takaNo, "text", false, "", true, "", ""),
        },
        {
            field: RowsField.ends,
            //modSetting&& modeSettingParams&& modeSettingParams.Value.mcNoPosition != "BEFORE" ? RowsField.mcNo : RowsField.mcNoBefore,
            headerName: "Ends",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => <InputCell
                row={row}
                input_id={RowsField.ends}
                input_type="text"
                is_readonly={false}
                holder_text=""
                is_required={true}
                variant="bordered"
                color="primary"
                handleInputChange={handleInputChange}
                handleKeyDown={handleKeyDown}
                hanldeBlur={hanldeBlur}
            />// renderInputCell(row, RowsField.mcNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.shade,
            headerName: "Shade",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.shade}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            // renderInputCell(row, RowsField.beamNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.colorId,
            headerName: "Color",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.colorId}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            // renderInputCell(row, RowsField.beamNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.perMtrWeight,
            headerName: `Weight /${costSetting} Meter`,
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.perMtrWeight}
                    input_type="text"
                    is_readonly={true}
                    holder_text=""
                    is_required={true}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            // renderInputCell(row, RowsField.meter, "number", false, "", true, "", ""),
        },

        {
            field: RowsField.wastagePer,
            headerName: "Wastage %",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.wastagePer}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            // renderInputCell(row, RowsField.weight, "number", false, "", false, "", ""),

        },
        {
            field: RowsField.wastageWeight,
            headerName: "Wastage Weight",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.wastageWeight}
                    input_type="text"
                    is_readonly={true}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            // renderInputCell(row, RowsField.avgWeight, "number", false, "", false, "", ""),

        },
        {
            field: RowsField.totalWeight,
            headerName: "Total Weight",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.totalWeight}
                    input_type="text"
                    is_readonly={true}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    handleInputChange={handleInputChange}
                    handleKeyDown={handleKeyDown}
                    hanldeBlur={hanldeBlur}
                />
            //    renderInputCell(row, RowsField.kgs, "number", false, "", false, "", ""),

        },

    ]
    const columnsWeft = [
        {
            field: RowsField.id,
            headerName: "No.",
            width: 30,
            headerAlign: "center",
            align: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <div className="flex gap-2 font-semibold ">
                    {row.id}
                    <strong>
                        <FontAwesomeIcon
                            color="red"
                            className="cursor-pointer text-md"
                            onClick={() => handleDeleteRow(row.id, gridWeft)}
                            icon={faSquareXmark}

                        ></FontAwesomeIcon>
                    </strong>
                </div>
            ),
        },
        {
            field: RowsField.fedNo,
            headerName: "Fed No.",
            width: 70,
            headerAlign: "center",
            align: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <InputCell
                    row={row}
                    input_id={RowsField.fedNo}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={true}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            ),
        },
        {
            field: RowsField.fedType,
            headerName: "feeder",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.fedType}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            //renderInputCell(row, RowsField.takaNo, "text", false, "", true, "", ""),
        },
        {
            field: RowsField.totalPick,
            headerName: "total Pick",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.totalPick}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={true}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            //renderInputCell(row, RowsField.takaNo, "text", false, "", true, "", ""),
        },
        {
            field: RowsField.itemCode,
            headerName: "Yarn Item Code",
            width: 100,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.itemCode}
                    input_type="text"
                    is_readonly={true}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            //renderInputCell(row, RowsField.itemCode, "text", true, "", false, "", ""),

        },
        {
            field: RowsField.itemName,
            headerName: "Yarn Item Name",
            width: 200,
            //isVisible:true,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <Autocomplete
                    isRequired
                    size="sm"
                    id={RowsField.itemName}
                    eventResizeFeature={true}
                    selectionMode="single"
                    showScrollIndicators={true}
                    placeholder="--Select--"
                    className="max-w-23"
                    isLoading={isLoading}
                    isClearable={false}
                    readOnly={false}
                    isVirtualized
                    value={row.itemName}
                    menuTrigger={"input"}
                    defaultItems={
                        masterData && masterData.yarnMaster ? masterData?.yarnMaster : []
                    }
                    onSelectionChange={(e) =>
                        handleAutoCompleteChange(e, row.id, "", gridWeft)
                    }
                    selectedKey={row.itemCode}
                    color={"warning"}
                    variant="flat"
                >
                    {(item) => (
                        <AutocompleteItem
                            key={item.Item_Code}
                        >
                            {item.Item_Code + "(" + item.Item_Desc + ")"}
                        </AutocompleteItem>
                    )}
                </Autocomplete>


            ),
        },
        {
            field: RowsField.denier,
            headerName: "Denier",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.denier}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={true}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            //renderInputCell(row, RowsField.takaNo, "text", false, "", true, "", ""),
        },
        {
            field: RowsField.size,
            //modSetting&& modeSettingParams&& modeSettingParams.Value.mcNoPosition != "BEFORE" ? RowsField.mcNo : RowsField.mcNoBefore,
            headerName: " S / Z",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => <InputCell
                row={row}
                input_id={RowsField.size}
                input_type="text"
                is_readonly={false}
                holder_text=""
                is_required={false}
                variant="bordered"
                color="primary"
                gridType={gridWeft}
                handleInputChange={handleWeftInputChange}
                handleKeyDown={handleWeftKeyDown}
                hanldeBlur={hanldWefteBlur}
            />// renderInputCell(row, RowsField.mcNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.shade,
            headerName: "Shade",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.shade}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            // renderInputCell(row, RowsField.beamNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.colorId,
            headerName: "Color",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.colorId}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            // renderInputCell(row, RowsField.beamNo, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.perMtrWeight,
            headerName: `Weight /${costSetting} Meter`,
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.perMtrWeight}
                    input_type="text"
                    is_readonly={true}
                    holder_text=""
                    is_required={true}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            // renderInputCell(row, RowsField.meter, "number", false, "", true, "", ""),
        },

        {
            field: RowsField.wastagePer,
            headerName: "Wastage %",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.wastagePer}
                    input_type="text"
                    is_readonly={false}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            // renderInputCell(row, RowsField.weight, "number", false, "", false, "", ""),

        },
        {
            field: RowsField.wastageWeight,
            headerName: "Wastage Weight",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.wastageWeight}
                    input_type="text"
                    is_readonly={true}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            // renderInputCell(row, RowsField.avgWeight, "number", false, "", false, "", ""),

        },
        {
            field: RowsField.totalWeight,
            headerName: "Total Weight",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                <InputCell
                    row={row}
                    input_id={RowsField.totalWeight}
                    input_type="text"
                    is_readonly={true}
                    holder_text=""
                    is_required={false}
                    variant="bordered"
                    color="primary"
                    gridType={gridWeft}
                    handleInputChange={handleWeftInputChange}
                    handleKeyDown={handleWeftKeyDown}
                    hanldeBlur={hanldWefteBlur}
                />
            //    renderInputCell(row, RowsField.kgs, "number", false, "", false, "", ""),

        },

    ]


    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData({ ...formData, [name]: value })
    }
    
    const handleAutoCompleteChange = (value, rowid, name, gridType) => {
        if (name == formField.grayItemCode) {

            funGetDetail({
                data: {
                    mitem_code: value
                },
                onSuccess: (data) => {
                    if (data && Object.keys(data).length > 0) {
                        if (data.warpData.length > 0 || data.weftData.length > 0) {
                            dispatch(setNewEntryMode(false))
                            dispatch(setDetailParams({ MItem_Code: value }))
                        }
                        else {
                            dispatch(resetDetailParams())
                            setRows([])
                            setRowsWeft([])
                        }
                    }
                }
            })
            setFormData({
                ...formData,
                [name]: value,
            })
        }
        else {
            const index = gridType == gridWeft ? rowsWeft.findIndex((ele) => ele.id == rowid) : rows.findIndex((ele) => ele.id == rowid)
            const tempdata = masterData.yarnMaster
            const itemData = tempdata.filter((ele) => ele.Item_Code == value)
            if (itemData && itemData.length > 0) {
                if (gridType == gridWeft) {
                    setRowsWeft((prevData) => {
                        const newData = [...prevData];
                        const updatedArray = { ...newData[index], [RowsField.itemCode]: value }
                        newData[index] = updatedArray;
                        return newData
                    })
                }
                else {
                    setRows((prevData) => {
                        const newData = [...prevData];
                        const updatedArray = { ...newData[index], [RowsField.itemCode]: value }
                        newData[index] = updatedArray;
                        return newData
                    })
                }


            }
        }
    }
    const funGenGridRows = (no_ofrows, gridType) => {

        if (gridType == gridWeft) {
            let newRowsId = rowsWeft.length + 1
            const newRow = {
                id: newRowsId, ...initialRowWeft, [RowsField.wastagePer]: itemSettings?.defWeftWastage || 0

            }
            setRowsWeft([...rowsWeft, newRow])
            setTimeout(() => {
                const gridScroller = gridContainerWeftRef.current.querySelector('.MuiDataGrid-virtualScroller');
                if (gridScroller) {
                    gridScroller.scrollLeft = 0; // Scroll to the left
                }
            }, 250)
            setTimeout(() => {
                const firstCell = gridContainerWeftRef.current?.querySelector(
                    `[data-id="${newRowsId}"] [data-field="id"]`
                );
                if (firstCell) {
                    firstCell.focus();
                }
            }, 500);
        }
        else {
            let newRowsId = rows.length + 1
            const newRow = {
                id: newRowsId, ...initialRow, [RowsField.wastagePer]: itemSettings?.defWarpWastage || 0
            }
            setRows([...rows, newRow])
            setTimeout(() => {
                const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
                if (gridScroller) {
                    gridScroller.scrollLeft = 0; // Scroll to the left
                }
            }, 250)
            setTimeout(() => {
                const firstCell = gridContainerRef.current?.querySelector(
                    `[data-id="${newRowsId}"] [data-field="id"]`
                );
                if (firstCell) {
                    firstCell.focus();
                }
            }, 500);
        }
    }

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {

                if (rows[i].itemCode == "" || rows[i].itemCode == "0") {
                    if (!msg.includes("Item"))
                        msg = msg + "  Item ,";
                    no = 1
                }
                if (rows[i].perMtrWeight == "" || rows[i].perMtrWeight == "0") {
                    if (i != rows.length - 1) {
                        if (!msg.includes("Weight"))
                            msg = msg + " Per Meter Weight ,";
                        no = 1
                    }
                    // if(i==rows.length-1)
                    // {
                    // //    const newData= rows.filter(ele=>ele.id!=rows[rows.length-1].id)
                    // //     setRows(newData)
                    // }
                }
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required"
        else return ""
    }

    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        if (formData[formField.grayItemCode].trim() === "" || formData[formField.grayItemCode] == "0") {
            newErrors[formField.grayItemCode] = "Gray Item is required"
        }

        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    // useEffect(() => {
    //     validateForm();
    // }, [formData])

    const handleSubmit = (e) => {
        e.preventDefault()


        const grid_msg = ValidateGrid();
        const validate_form = validateForm()
        //grid_msg == "" && 
        if (validate_form) {
            let warpData = rows;
            if (rows.length > 1) {
                let last_inx = rows.length - 1
                if (rows[last_inx].denier == "0" || rows[last_inx - 1].denier == "") {
                    warpData = rows.slice(0, last_inx)
                }
            }
            let weftData = rowsWeft;
            if (rowsWeft.length > 1) {
                let last_inx = rowsWeft.length - 1
                if (rowsWeft[last_inx].denier == "0" || rowsWeft[last_inx - 1].denier == "") {
                    weftData = rowsWeft.slice(0, last_inx)
                }
            }
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    master_item: formData.grayItemCode,
                    warp_list: warpData,
                    weft_list: weftData,
                    deleteditems_warp: deletedItemRows,
                    deleteditems_weft: deletedWeftItemRows,
                    login_userid: user.username,
                    width: itemSettings.defWidth,
                    pick: totPick,
                    base_pick: basePick,
                    avgkgs: (grandTotals.totalWeight + grandTotals.wastageWeight).toFixed(3),
                    pick_const: itemSettings?.defPickConst,
                    weave_rate: weavRate,
                    weaverate_perpick: weavRatePerPick,
                    rec_status: !isNewEntry ? 1 : 2,
                }
            })
        }
        else {
            toast.error(grid_msg, {
                "position": "top-center"
            })
        }

    }

    const handleDeleteRow = (id, gridType) => {

        if (gridType == gridWeft) {
            const updatedRows = rowsWeft.filter((row) => row.id !== id)
            let DeletedRow = rowsWeft.filter((row) => row.id == id)
            setRowsWeft(updatedRows)
            setDeletedWeftItemRows([...deletedWeftItemRows, ...DeletedRow])
        }
        else {
            const updatedRows = rows.filter((row) => row.id !== id)
            let DeletedRow = rows.filter((row) => row.id == id)
            setRows(updatedRows)
            setDeletedItemRows([...deletedItemRows, ...DeletedRow])
        }
    }


    const hanldeCheckChange = (event) => {

        if (formData.qualityId != "" && formData.qualityId != "0") {
            //  setIsSameQuality(event.target.checked)
        }
        else {
            //  setIsSameQuality(false)
            toast.error("select Quality", {
                "position": "top-center"
            })
        }
    }

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            if (detail && Object.keys(detail).length > 0) {
                const { MItem_Code } = detailParams

                const warpData = detail?.warpData?.map((item, i) => {

                    return {
                        id: ++i,
                        [RowsField.detailId]: item?.DetailId ?? 0,
                        [RowsField.denier]: item?.Denier ?? 0,
                        //[RowsField.itemName]: item?.item_name ?? "",
                        [RowsField.itemCode]: item?.WItem_Code ?? "",
                        [RowsField.ends]: item?.Ends ?? 0,
                        [RowsField.shade]: item?.Shade ?? "",
                        [RowsField.colorId]: item?.Color_Id ?? "",
                        [RowsField.perMtrWeight]: item?.PerMtr_Weight ?? 0,
                        [RowsField.wastagePer]: item?.Wastage_Per ?? 0,
                        [RowsField.wastageWeight]: item?.Wastage_Weight ?? 0,
                        [RowsField.entryOf]: item?.Entry_Of ?? '',
                        [RowsField.totalWeight]: (item?.Wastage_Weight + item?.PerMtr_Weight).toFixed(2),
                    }
                })

                const weftData = detail?.weftData?.map((item, i) => {
                    return {
                        id: ++i,
                        [RowsField.detailId]: item?.DetailId ?? 0,
                        [RowsField.denier]: item?.Denier ?? 0,
                        [RowsField.fedNo]: item?.Fed_No ?? 0,
                        [RowsField.fedType]: item?.Fed_Type ?? "",
                        //[RowsField.itemName]: item?.item_name ?? "",
                        [RowsField.size]: item?.S_Z ?? '',
                        [RowsField.itemCode]: item?.WItem_Code ?? "",
                        [RowsField.totalPick]: item?.Pick_Total ?? 0,
                        [RowsField.shade]: item?.Shade ?? "",
                        [RowsField.colorId]: item?.Color_Id ?? "",
                        [RowsField.perMtrWeight]: item?.PerMtr_Weight ?? 0,
                        [RowsField.wastagePer]: item?.Wastage_Per ?? 0,
                        [RowsField.wastageWeight]: item?.Wastage_Weight ?? 0,
                        [RowsField.totalWeight]: (item?.Wastage_Weight + item?.PerMtr_Weight).toFixed(2),
                    }
                })

                if (detail?.weftData?.length > 0) {
                    setWeavRatePerPick(detail?.weftData[0].Weave_Rate_PerPick)
                    setItemSettings({
                        defWidth: detail?.weftData[0].Width || getModValue(ENUM_MOD_PARAMETER.masterItem.DefWidth, modSetting),
                        defWarpWastage: getModValue(ENUM_MOD_PARAMETER.masterItem.DefWarpWastage, modSetting),
                        defWeftWastage: getModValue(ENUM_MOD_PARAMETER.masterItem.DefWeftWastage, modSetting),
                        defPickConst: detail?.weftData[0].Pick_Constant || getModValue(ENUM_MOD_PARAMETER.masterItem.DefPickConstant, modSetting)
                    })
                }
                setBasePick(detail?.weftData[0]?.Base_Pick || 0)
                setRows(warpData)
                setRowsWeft(weftData)
                setFormData({
                    ...formData,
                    grayItemCode: MItem_Code
                })
            }

        }

    }, [detail])

    const handleClickPrev = () => {
        navigate(linksUrl.masterItemEntry.masterItemEntryMaster)
    }
    const handleAddRow = (gridType) => {

        funGenGridRows(1, gridType);
    }

    const warpTotals = useMemo(() => {
        return rows.reduce(
            (acc, row) => {
                acc.denier += parseFloat(row[RowsField.denier] || 0);
                acc.ends += parseFloat(row[RowsField.ends] || 0);
                acc.perMtrWeight += parseFloat(row[RowsField.perMtrWeight] || 0);
                acc.wastageWeight += parseFloat(row[RowsField.wastageWeight] || 0);
                acc.totalWeight += parseFloat(row[RowsField.totalWeight] || 0);
                return acc;
            },
            {
                denier: 0,
                ends: 0,
                perMtrWeight: 0,
                totalWeight: 0,
                wastageWeight: 0,
            }
        );
    }, [rows]);

    const weftTotals = useMemo(() => {
        return rowsWeft.reduce(
            (acc, row) => {
                acc.denier += parseFloat(row[RowsField.denier] || 0);
                acc.totalPick += parseFloat(row[RowsField.totalPick] || 0);
                acc.perMtrWeight += parseFloat(row[RowsField.perMtrWeight] || 0);
                acc.wastageWeight += parseFloat(row[RowsField.wastageWeight] || 0);
                acc.totalWeight += parseFloat(row[RowsField.totalWeight] || 0);
                return acc;
            },
            {
                denier: 0,
                totalPick: 0,
                perMtrWeight: 0,
                totalWeight: 0,
                wastageWeight: 0
            }
        );
    }, [rowsWeft]);

    const totPick = useMemo(() => {
        if (itemSettings && Object.keys(itemSettings).length > 0) {
            const tot = parseFloat(weftTotals?.totalPick);
            const pickConst = parseFloat(itemSettings?.defPickConst);

            // invalid or zero divisor → return 0
            if (!Number.isFinite(tot) || !Number.isFinite(pickConst) || pickConst === 0) {
                return "0";
            }

            const result = tot / pickConst;

            // final safety check
            if (!Number.isFinite(result)) {
                return "0";
            }

            return result.toFixed(2);
        }
    }, [weftTotals, itemSettings?.defPickConst]);

    const handleItemSettingBlur = (e) => {
        const { value, name } = e.target
        const width = name == "defWidth" ? value : itemSettings?.defWidth || 0
        const pickConst = name == "defPickConst" ? value : itemSettings?.defPickConst || 0
    }
    useEffect(() => {
        if (!itemSettings) return;

        const width = parseFloat(itemSettings.defWidth);
        const pickConst = parseFloat(itemSettings.defPickConst);

        // 🚫 Hard stop if invalid
        if (!width || !pickConst) return;

        setRowsWeft(prevRows =>
            prevRows.map(row => {
                const denier = parseFloat(row[RowsField.denier]);
                const totalPick = parseFloat(row[RowsField.totalPick]);

                if (!denier || !totalPick) return row;

                const pick = totalPick / pickConst;

                const perMtrWt = calcWeftWeight(width, pick, denier);

                if (!Number.isFinite(perMtrWt)) return row;

                const updatedRow = {
                    ...row,
                    [RowsField.perMtrWeight]: Number(perMtrWt.toFixed(3)),
                };

                const calc = calculateWeight(updatedRow);

                return {
                    ...updatedRow,
                    [RowsField.wastageWeight]: calc.wastageWt || 0,
                    [RowsField.totalWeight]: calc.totalWeight || 0,
                };
            })
        );
    }, [itemSettings]);

    const weavRate = useMemo(() => {
        const tot = parseFloat(weftTotals.totalPick) || 0;
        const ratePerPick = parseFloat(weavRatePerPick) || 0;

        const Rate = (tot * ratePerPick) // 2 decimals, change as needed
        return (Rate / 10).toFixed(2)
    }, [weftTotals, weavRatePerPick]);

    const grandTotals = useMemo(() => {

        return {
            totalWeight:
                (warpTotals.perMtrWeight || 0) +
                (weftTotals.perMtrWeight || 0),

            wastageWeight:
                (warpTotals.wastageWeight || 0) +
                (weftTotals.wastageWeight || 0),
        };
    }, [warpTotals, weftTotals]);
    const funFilterYarnCost = () => {
        funGetYarnCost({
            data: {
                item_code: formData?.grayItemCode || ""
            }
        })
    }
    useEffect(() => {
        funFilterYarnCost()
    }, [formData])

    const handleYarnCost = () => {
        setOpenDrawer(true)
        funFilterYarnCost()


    }
    const hanldeClick = () => {
        setOpenDrawer(false)

    }
    const handleRateChange = (index, value) => {
        //  const valid = funValidateNoInput(value)
        //if (valid) {
        const updatedRows = [...yarnCostData];
        updatedRows[index].rate = parseFloat(value);
        updatedRows[index].amount = (parseFloat(value) * parseFloat(updatedRows[index].total_weight));
        setYarnCostData(updatedRows);
        // }
    };

    const handleUpdateRate = () => {
        funUpdateItemRate({
            data: {
                comp_code: compCode.join(","),
                item_list: yarnCostData,
                login_user: user.username
            }
        })

    }

    const hanldelResetRate = () => {

        funFilterYarnCost()
    }
    const totalWeight = yarnCostData.reduce(
        (sum, item) => sum + Number(item.total_weight || 0),
        0
    );

    const totalAmount = yarnCostData.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
    );
    const calYarnCost = useMemo(() => {
        // const totalAmount = yarnCostData.reduce(
        //     (acc, row) => acc + row.amount,
        //     0
        // );
        if (costSetting > 0)
            return (totalAmount / Number(costSetting)).toFixed(2)
        else
            return (totalAmount / 100).toFixed(2) || 0
    }, [yarnCostData, totalAmount])

    // if (isPending) {
    //     return <LoadingCard />;
    // }


    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} Master Item Entry `}
                breadcrumbs={["Master", "Items", "Master Item Entry"]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >

                <div shadow="sm" className="mb-3 w-full">
                    {/* <Test /> */}
                    {/* {itemSettings && Object.keys(itemSettings).length > 0 ? */}
                    <Drawer open={openDrawer} anchor="top"  >
                        <div className="text-center text-red-600 font-semibold py-1 px-5 border-b-2 border-slate-700">
                            Yarn  Cost
                            {/* <FontAwesomeIcon onClick={hanldeClick} className="  cursor-pointer text-red-800 text-3xl " icon={faSquareXmark} /> */}
                        </div>
                        <div className="p-5">

                            <div className="overflow-x-auto">
                                <div className="inline-block text-xs min-w-full align-middle">
                                    <div className="shadow border rounded-lg overflow-hidden">

                                        {/* HEADER (Fixed) */}
                                        <div className="grid grid-cols-5 uppercase bg-slate-50 border-b font-semibold text-gray-700 sticky top-0 z-10">
                                            <div className="p-2 border-r text-center">Item</div>
                                            <div className="p-2 border-r text-center">Weight</div>
                                            <div className="p-2 border-r text-center">Rate</div>
                                            <div className="p-2 text-center">Amount</div>
                                        </div>

                                        {/* BODY (Scrollable) */}
                                        <div className="max-h-64 overflow-y-auto">
                                            {yarnCostData.map((ele, index) => (
                                                <div
                                                    key={ele.item_code}
                                                    className={`grid grid-cols-5 border-b items-center ${index % 2 === 0 ? "bg-white" : "bg-lfate-50"
                                                        }`}
                                                >
                                                    <div className="p-1 border-r">{ele.item_desc}</div>

                                                    <div className="p-1 border-r text-right">
                                                        {ele.total_weight.toFixed(4)}
                                                    </div>

                                                    <div className="p-1 border-r text-right">
                                                        <input
                                                            type="number"
                                                            className="w-26 p-1 border border-blue-300 rounded text-right"
                                                            value={ele.rate}
                                                            onChange={(e) =>
                                                                handleRateChange(index, e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    <div className="p-1 text-right">
                                                        {ele.amount.toFixed(4)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* FOOTER TOTAL (Fixed) */}
                                        <div className="grid grid-cols-5 bg-slate-100 font-semibold border-t sticky bottom-0 z-10">
                                            <div className="p-2 border-r text-right">Total</div>
                                            <div className="p-2 border-r text-right">
                                                {totalWeight.toFixed(4)}
                                            </div>
                                            <div className="p-2 border-r text-center">—</div>
                                            <div className="p-2 text-right">
                                                {totalAmount.toFixed(4)}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <h4 className="text-red-600 font-semibold bg-lime-50 p-2 text-center">Cost : {calYarnCost}</h4>
                            <div className="flex justify-center mt-5 gap-5" ><Button className=" bg-red-600 text-white h-7 uppercase" size="sm" color="success" onPress={handleUpdateRate}>Update Rate</Button>
                                <Button className=" bg-lime-600 text-white h-7 uppercase" size="sm" color="success"
                                    onPress={hanldelResetRate}>Reset Rate</Button>
                                <Button className=" bg-slate-600 text-white h-7 uppercase" size="sm" color="success" onPress={hanldeClick}>Close</Button>
                            </div>
                        </div>
                    </Drawer>
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        {
                            Object.keys(inputBoxes).map((key, ind) => (
                                <div key={key + ind}>
                                    <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                        {
                                            inputBoxes[key].map((item, indx) =>
                                                item.type == ENUM_INPUT_TYPE.select ? (
                                                    <></>
                                                ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                    <Autocomplete
                                                        size="md"
                                                        name={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        label={item?.placeholder}
                                                        eventResizeFeature={true}
                                                        selectionMode="single"
                                                        showScrollIndicators={true}
                                                        labelPlacement={"outside"}
                                                        placeholder={item.placeholder}
                                                        menuTrigger="input"
                                                        isRequired={item.isrequired}
                                                        isLoading={isLoading}
                                                        className="max-w-23"
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                        isClearable={false}
                                                        isVirtualized
                                                        // isReadOnly={isNewEntry ? false : true}
                                                        defaultItems={
                                                            item.data ? item.data : []
                                                        }
                                                        onSelectionChange={(e) =>
                                                            handleAutoCompleteChange(e, "", item.name, "")
                                                        }
                                                        color={item.id == formField.grayItemCode ? "danger" : item.id == formField.partyId ? "primary" : ""}
                                                        //onChange={handleFormSelectionChange}
                                                        selectedKey={formData[item.name]}
                                                    >
                                                        {(list) => (
                                                            <AutocompleteItem

                                                                key={list[item.itemkey]}
                                                            >
                                                                {list[item.itemvalue]}
                                                            </AutocompleteItem>
                                                        )}
                                                    </Autocomplete>


                                                ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                    <div className=" w-full flex items-center">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                label={item.placeholder}
                                                                views={["day", "month", "year"]}
                                                                format="DD/MM/YYYY"
                                                                value={
                                                                    formData[item.name]
                                                                        ? dayjs(formData[item.name])
                                                                        : formData[item.name]
                                                                }
                                                                onChange={(newValue) => {
                                                                    setFormData((prev) => {
                                                                        return {
                                                                            ...prev,
                                                                            [item.name]:
                                                                                dayjs(newValue).format("YYYY-MM-DD"),

                                                                        };
                                                                    });
                                                                }}
                                                                //isRequired={item.required}
                                                                className="w-full "
                                                                slotProps={{
                                                                    textField: { size: "small", required: true },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                ) : (
                                                    <Input
                                                        type={item.type}
                                                        name={item.name}
                                                        id={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        //aria-label={item.placeholder}
                                                        placeholder={item.placeholder}
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        isRequired={item.isrequired}
                                                        value={formData[item.name]}
                                                        variant="bordered"
                                                        disabled={isNewEntry ? false : true}
                                                        onChange={(e) => handleChange(e)}
                                                        onBlur={(e) => hanldeBlur("", e)}
                                                        isReadOnly={item.name == formField.challanNo ? true : false}
                                                        //  readOnly={item.name == formField.voucherNo ? true : false}
                                                        size={"md"}
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                    ></Input>
                                                )
                                            )
                                        }
                                    </div>

                                </div>

                            ))
                        }
                        <div className="mt-5">
                            <div>
                                <Button size="sm" color="success" className="text-white  font-semibold uppercase" startContent={<FontAwesomeIcon color="white" icon={faPlus} />} variant="shadow" onPress={() => handleAddRow("warp")}>
                                    Warp Yarn
                                </Button>
                            </div>
                            {rows && rows?.length > 0 ? (
                                <div>
                                    <Box ref={gridContainerRef} sx={{
                                        overflow: "scroll",
                                        height: rowsWeft.length > 5 ? 300 : "auto", width: '100%',
                                    }}>
                                        {/* style={{ height: 50+ Number(rows.length * 51), width: "100%", maxHeight: "500px", overflow: "auto" }}> */}
                                        <DataGrid
                                            // ref={gridContainerRef}
                                            rows={rows}
                                            columns={columns}
                                            editMode="row"
                                            hideFooterPagination={rows && rows.length > 100 ? false : true}
                                            hideFooter={rows && rows.length > 100 ? false : true}
                                            columnHeaderHeight={40}
                                            disableColumnMenu={false}
                                            rowHeight={45}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaders': {
                                                    position: 'sticky',
                                                    top: 0,
                                                    fontWeight: "bold",
                                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                },
                                                '& .MuiDataGrid-menuIcon': {
                                                    visibility: 'visible',
                                                    opacity: 1,
                                                    width: 'auto',
                                                },
                                                // '& .MuiDataGrid-menuIcon button': {

                                                //     backgroundColor: "#ffffff",
                                                // },
                                                '& .MuiDataGrid-menuIcon svg': {
                                                    color: '#fffcfcff',

                                                },
                                                "& .MuiDataGrid-columnHeaderTitle": {
                                                    whiteSpace: "normal",
                                                    lineHeight: "1.5",
                                                    textAlign: "center",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                },
                                                "& .MuiDataGrid-columnHeader": {
                                                    height: "auto !important",
                                                },
                                                "& .MuiDataGrid-columnHeaders": {
                                                    maxHeight: "none !important",
                                                },

                                            }}
                                            disableColumnSorting={true}
                                        />
                                    </Box>
                                    <div className="mt-3 p-3 border rounded bg-lime-50 flex  flex-wrap sm:flex-nowrap md:flex-nowrap gap-2 sm:gap-4 md:gap-6 text-sm font-semibold">
                                        <div>Denier: <span className="text-blue-600">{warpTotals.denier.toFixed(3)}</span></div>
                                        <div>Ends: <span className="text-blue-600">{warpTotals.ends.toFixed(3)}</span></div>
                                        <div>Weight /{costSetting} Meter: <span className="text-blue-600">{warpTotals.perMtrWeight.toFixed(3)}</span></div>
                                        <div>Wastage : <span className="text-blue-600">{warpTotals.wastageWeight.toFixed(3)}</span></div>
                                        <div>Total Weight /{costSetting} Meter: <span className="text-blue-600">{warpTotals.totalWeight.toFixed(3)}</span></div>
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="mt-5">
                            <div>
                                <Button size="sm" color="warning" className="text-white font-semibold uppercase " startContent={<FontAwesomeIcon color="white" icon={faPlus} />} variant="shadow" onPress={() => handleAddRow("weft")}>
                                    Weft Yarn
                                </Button>
                            </div>
                            {rowsWeft && rowsWeft?.length > 0 ? (
                                <div>
                                    <Box ref={gridContainerWeftRef} sx={{
                                        overflow: "scroll",
                                        height: rowsWeft.length > 5 ? 300 : "auto", width: '100%',
                                    }}>
                                        {/* style={{ height: 50+ Number(rows.length * 51), width: "100%", maxHeight: "500px", overflow: "auto" }}> */}
                                        <DataGrid
                                            // ref={gridContainerRef}
                                            rows={rowsWeft}
                                            columns={columnsWeft}
                                            editMode="row"
                                            hideFooterPagination={rowsWeft && rowsWeft.length > 100 ? false : true}
                                            hideFooter={rowsWeft && rowsWeft.length > 100 ? false : true}
                                            columnHeaderHeight={50}
                                            disableColumnMenu={false}
                                            rowHeight={45}

                                            sx={{
                                                '& .MuiDataGrid-columnHeaders': {
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                },
                                                '& .MuiDataGrid-menuIcon': {
                                                    visibility: 'visible',
                                                    opacity: 1,
                                                    width: 'auto',
                                                },
                                                // '& .MuiDataGrid-menuIcon button': {

                                                //     backgroundColor: "#ffffff",
                                                // },
                                                '& .MuiDataGrid-menuIcon svg': {
                                                    color: '#fffcfcff',

                                                },
                                                "& .MuiDataGrid-columnHeaderTitle": {
                                                    whiteSpace: "normal",
                                                    lineHeight: "1.3",
                                                    textAlign: "center",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    fontSize: "10px",
                                                    fontWeight: "bold",
                                                },
                                                "& .MuiDataGrid-columnHeader": {
                                                    height: "auto !important",
                                                },
                                                "& .MuiDataGrid-columnHeaders": {
                                                    maxHeight: "none !important",
                                                },

                                            }}
                                            disableColumnSorting={true}
                                        />
                                    </Box>
                                    <div className="mt-3 p-2 border rounded bg-orange-50  text-sm font-semibold">
                                        <div className="flex  flex-wrap sm:flex-nowrap md:flex-nowrap gap-3 sm:gap-4 md:gap-6   items-center">
                                            {/* <div>Denier: <span className="text-blue-600">{weftTotals.denier.toFixed(2)}</span></div> */}
                                            {/* <div>Total Picks: <span className="text-blue-600">{weftTotals.totalPick.toFixed(2)}</span></div> */}
                                            <div>Weight /{costSetting} Meter: <span className="text-blue-600">{weftTotals.perMtrWeight.toFixed(3)}</span></div>
                                            <div>Wastage : <span className="text-blue-600">{weftTotals.wastageWeight.toFixed(3)}</span></div>

                                            <div>Total Weight /{costSetting} Meter: <span className="text-blue-600">{weftTotals.totalWeight.toFixed(3)}</span></div>
                                            {/* <div className="flex gap-3 p-2 items-center  ">
                                                <h2>Base Pick :</h2>
                                                <Input type="number"
                                                    size="sm"
                                                    onChange={(e) => setBasePick(e.target.value)}
                                                    value={basePick}
                                                    className="w-16 bg-white" variant="bordered" label=""></Input>

                                            </div> */}

                                        </div>
                                        <div className="flex mt-5 flex-wrap sm:flex-nowrap md:flex-nowrap gap-3 sm:gap-4 md:gap-6">
                                            <div className="flex gap-3  items-center  ">
                                                <h2>Weaving Rate / Pick :</h2>
                                                <Input type="text"
                                                    size="sm"
                                                    onChange={(e) => funValidateNoInput(e.target.value) ? setWeavRatePerPick(e.target.value) : ""}
                                                    value={weavRatePerPick}
                                                    className="w-24 bg-white" variant="bordered" label=""></Input> Rate :<span className="text-blue-600">{weavRate}</span>

                                            </div>
                                            <div className="flex gap-3  items-center  ">
                                                <h2>Width :</h2>
                                                <Input type="text"
                                                    size="sm"
                                                    name="defWidth"
                                                    onChange={(e) => funValidateNoInput(e.target.value) ? setItemSettings({ ...itemSettings, defWidth: e.target.value }) : ""}
                                                    value={itemSettings?.defWidth}
                                                    onBlur={handleItemSettingBlur}
                                                    className="w-24 bg-white" variant="bordered" label=""></Input>
                                            </div>
                                            <div className="flex gap-3  items-center  ">
                                                Total Picks
                                                <span className="text-blue-600">
                                                    {weftTotals.totalPick.toFixed(2)}</span> /   <Input type="text"
                                                        size="sm"
                                                        name="defPickConst"
                                                        onChange={(e) => funValidateNoInput(e.target.value) ? setItemSettings({ ...itemSettings, defPickConst: e.target.value }) : ""}
                                                        value={itemSettings?.defPickConst}
                                                        onBlur={handleItemSettingBlur}
                                                        className="w-24 bg-white" variant="bordered" label=""></Input> = {totPick}
                                            </div>{isNewEntry  && !showYarnCost? "" :
                                                <div className="bg-white px-5 items-center gap-3 flex text-blue-700 text-md">
                                                    Yarn Cost : <span className="text-red-600">{calYarnCost}</span>
                                                </div>}

                                        </div>

                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        {rows.length > 0 || rowsWeft.length > 0 ?
                            <div className="bg-bdlue-50 p-2 my-2 border-1  shadow-md border-gray-100">
                                <h2 className=" font-semibold text-rose-600">Total Yarn Consumption</h2>
                                <div className="flex justify-between gap-5">
                                    <div className="flex flex-wrap sm:flex-nowrap md:flex-nowrap  gap-1 sm:gap-5 md:gap-5 justify-start font-semibold">
                                        <div><span className="text-sm">Weight (KGS) : </span><span className=" text-rose-600">{grandTotals.totalWeight.toFixed(3)}</span></div>
                                        <div><span className="text-sm">Wastage (KGS) : </span><span className="text-rose-600">{grandTotals.wastageWeight.toFixed(3)}</span></div>
                                        <div><span className="text-sm">Total Qlty.Wght /{costSetting} MTR : </span> <span className="text-rose-600">{(grandTotals.totalWeight + grandTotals.wastageWeight).toFixed(3)}</span></div>
                                    </div>
                                    {isNewEntry && !showYarnCost ? "" :
                                        <Button size="sm" color="danger" className="w-2/5 bg-blue-700 uppercase" onPress={handleYarnCost}>Yarn Cost</Button>}
                                </div>
                            </div> : ""}
                        <div className="justify-center flex gap-5 mt-5">
                            <Button
                                color="primary"
                                type="submit"
                                size="sm"
                                variant="shadow"
                                isLoading={isPending}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Submit
                            </Button>
                            <Button
                                color="danger"
                                variant="shadow"
                                size="sm"
                                onPress={handleClickPrev}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancel
                            </Button>
                        </div>
                    </form>

                </div>
            </MainContainer>
        </div>
    )

}
export default CreateMasterItem